import * as z from 'zod';

export const fileQuerySchema = z.object({
  id: z.number(),
  url: z.string(),
  name: z.string().nullish(),
  s3_path: z.string().nullish(),
  folder_path: z.string().nullish(),
  mime_type: z.string().nullish(),
  guid: z.string().nullish(),
  etag: z.string().nullish().nullish(),
  access_level: z.string().nullish(),
  file_size: z.number().nullish(),
  created_at: z.string().nullish(),
  updated_at: z.string().nullish(),
});

export type FileQuerySchema = z.infer<typeof fileQuerySchema>;
